exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._3G8z_IybCp1JuEj6El2vKB{font-size:14px;margin-right:12px}", ""]);

// exports
exports.locals = {
	"passwordSet": "_3G8z_IybCp1JuEj6El2vKB"
};